import {
  Order,
  OrderableType,
  OrderItem,
  OrderItemDayPass,
  OrderItemHourlyPass,
  OrderItemMembership,
  OrderItemMultiPass,
  OrderStatus,
} from "./api";

export function getBookingOrderItem(
  order: Order
): OrderItemDayPass | OrderItemHourlyPass | OrderItemMembership | undefined {
  const oi = order.orderItems.find(
    (oi) => "type" in oi && oi.type === OrderableType.Booking
  );

  if (oi && "type" in oi && oi?.type !== OrderableType.Booking) {
    return undefined;
  }

  return oi;
}

export function getMembershipOrderItem(order: Order): OrderItem | undefined {
  const membershipOrder = order.orderItems.find(
    (oi) => oi.type === OrderableType.Membership
  );

  if (!membershipOrder) {
    return undefined;
  }

  return membershipOrder;
}

export function getAddOnOrderItem(
  order: Order
): OrderItemMultiPass | undefined {
  const oi = order.orderItems.find((oi) => oi.type === OrderableType.AddOn);

  if (oi?.type !== OrderableType.AddOn) {
    return undefined;
  }

  return oi;
}

export function getMainOrderItem(order: Order) {
  return (
    getAddOnOrderItem(order) ||
    getBookingOrderItem(order) ||
    getMembershipOrderItem(order)
  );
}

export function displayStatus(status: OrderStatus) {
  switch (status) {
    case OrderStatus.Canceled:
      return "Canceled";
    case OrderStatus.Confirmed:
      return "Confirmed";
    case OrderStatus.Paid:
      return "Paid";
    case OrderStatus.Created:
      return "Created";
    case OrderStatus.Chargeback:
      return "Chargeback";
    default:
      return "";
  }
}
